import axios from 'axios'
import { toast } from 'react-hot-toast'

import { baseApiUrl } from '../configs/api'
import { COLORS } from '../constants/colors'

export const AxiosService = axios.create({
  baseURL: baseApiUrl
})

AxiosService.interceptors.request.use(
  async function (config) {
    const token = localStorage.getItem('token')
    const language = localStorage.getItem('language')
    if (token && config.headers) {
      config.headers.authorization = `Bearer ${token}`
    }
    if (language && config.headers) {
      config.headers['Accept-Language'] = language
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

AxiosService.interceptors.response.use(
  function (response) {
    const isUpdateStatusCommissionTransactions = response.config.url?.includes('/admin/commissions/transactions')
    if (
      response.config.method !== 'get' &&
      !response.data.imageUrl &&
      !response.data.fileUrl &&
      !isUpdateStatusCommissionTransactions
    ) {
      toast.success('Your request was successful!', {
        style: {
          color: 'white',
          backgroundColor: COLORS.blue500
        }
      })
    }
    return response
  },
  function (error) {
    const errorMessage = error.response.data.message || 'An Unexpected Error Occurred!'
    toast.error(errorMessage)
    return Promise.reject(error)
  }
)
